import { type ReactElement, type ReactNode } from 'react'
import { Navigate } from 'react-router-dom'

import { useCurrentAccount } from '@/contexts/CurrentAccountProvider'

type Props = { children: ReactNode }

const PlatformGuard = ({ children }: Props) => {
  const currentAccount = useCurrentAccount()
  if (!currentAccount || currentAccount.type !== 'PLATFORM') {
    return <Navigate to="/events" replace />
  }
  return children as ReactElement
}

export default PlatformGuard
